import { render, staticRenderFns } from "./ParcelsSettingsUldkAttributes.vue?vue&type=template&id=bdbf7354&scoped=true&"
import script from "./ParcelsSettingsUldkAttributes.vue?vue&type=script&lang=js&"
export * from "./ParcelsSettingsUldkAttributes.vue?vue&type=script&lang=js&"
import style0 from "./ParcelsSettingsUldkAttributes.vue?vue&type=style&index=0&id=bdbf7354&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbf7354",
  null
  
)

export default component.exports